import {getCurrentLayout} from "../../../../../appLayout";
import cabinetWorkspace from "./cabinetWorkspace";
import {APPLIANCE_PART_IDS, SHAPE_PART_ID, SHAPE_ROTATE_DIRECTION} from "../../../../constants";
import workspace from "../workspace";
import {createApplianceFromFeature} from "../../../../helpers/featureHelper";

class CabinetShapesLayout {

  /**
   * Create cabinets from cabinets data
   * @param positions
   */
   createShapesFromCabinetSet = (positions) => {
    const layout = getCurrentLayout();
    positions.forEach((cabinetData) => {
      if ([SHAPE_PART_ID.lower_cabinet_boxes, SHAPE_PART_ID.upper_cabinet_boxes].includes(cabinetData.partId)) {
        const feature = layout.getFeatureById(cabinetData.featureId, true);
        const parentFeature = layout.getFeatureById(cabinetData.parentFeatureId);
        if (feature && parentFeature) {
          const position = {x: cabinetData.x, y: cabinetData.z};
          const shapeId = cabinetWorkspace.cabinetShapes.addShape(feature, parentFeature, position);
          const shape = workspace.getShapeById(shapeId);
          shape.rotate(cabinetData.rotation, shape.Direction.LEFT);
        }
      } else if (APPLIANCE_PART_IDS.includes(cabinetData.partId) && cabinetData.featureId) {
        const feature = layout.getFeatureById(cabinetData.featureId, true);
        if (feature) {
          const movableImage = createApplianceFromFeature(feature);
          movableImage.setPosition({x: cabinetData.x, y: cabinetData.z});
          movableImage.rotate(cabinetData.rotation + 90, SHAPE_ROTATE_DIRECTION.left);
        }
      }
    })
  }
}

export default CabinetShapesLayout;
